import FlooringVariationOrganizerSelect from "./flooring-variation-organizer-select";

const FlooringVariationFormFields = {
  OrganizerSelect: FlooringVariationOrganizerSelect,
};

export default FlooringVariationFormFields;
